/**
 * @description
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType, ECommentStatus } from '@umu/umu-types';

export interface IInput {
    parent_type: CommentParentType;
    parent_id: number;
    comment_ids: string;
    status: ECommentStatus;
}

export interface IOutput {
    count: number;
}

export const commentSetStatus = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.COMMENT_SET_STATUS, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
